'use strict';

var AppNavigationDirective = function AppNavigationDirective() {
  return {
    restrict: 'E',
    controller: 'AppNavigationController',
    replace: true,
    template: require('../templates/navigation.html')
  };
};
AppNavigationDirective.$inject = [];
module.exports = AppNavigationDirective;